module.exports = __webpack_public_path__ + "media/images/icons/watch_history-ca019c59cf552a0d8b3c8cbc2aeca747.svg";